import clsx from 'clsx';

import { wrapperVariants } from './wrapperVariants';

import type { FieldSize, FieldVariant } from '../types';
import type { ComponentPropsWithRef } from 'react';

type WrapperProps = ComponentPropsWithRef<'div'> & {
  disabled?: boolean;
  fullWidth?: boolean;
  hasPrefix?: boolean;
  hasSuffix?: boolean;
  size?: FieldSize;
  variant?: FieldVariant;
};

export const Wrapper = ({
  children,
  className,
  disabled,
  fullWidth,
  hasPrefix,
  hasSuffix,
  size = 'default',
  variant = 'default',
  ...props
}: WrapperProps) => (
  <div
    className={clsx(
      wrapperVariants({
        disabled,
        fullWidth,
        hasPrefix,
        hasSuffix,
        size,
        variant,
      }),
      className,
    )}
    data-variant={variant}
    {...props}
  >
    {children}
  </div>
);
